import { useContext, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { AppBar, Box, Button, Container, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import Logo from '../assets/images/Logo_k2g.svg';
import { UserContext } from '../contexts/user';
import { GroupContext } from '../contexts/group';

const NavBar = () => {

    const {currentUser, setCurrentUser} = useContext(UserContext);
    const {currentGroup} = useContext(GroupContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
      };

    const handleClose= ()=>{
        setAnchorEl(null);
    }

    const handleLogOut = ()=>{
        setCurrentUser(null);
        localStorage.removeItem('userK2G');
        handleClose();
    }

    return (
    <>
        <AppBar sx={{backgroundColor:"white"}} position='static'>
            <Container maxWidth="false">
                <Toolbar disableGutters sx={{justifyContent:"space-between",padding:"10px 0px",position:"relative"}}>
                {
                    /* DESKTOP LOGO */
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <Link to="/">
                            <img src={Logo} className='logoImage' alt='LOGO_KNOW2GROW'/>
                        </Link>
                    </Box>
                }
                {
                    currentGroup?.name &&
                    <Box sx={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",pointerEvents:"none",maxWidth:{xs:"50%",sm:"60%"},px:1}}>
                        <Typography variant="h6" color="primary" fontWeight={600} textAlign="center" noWrap sx={{fontSize:{xs:"1rem",sm:"1.15rem",md:"1.25rem"}}}>
                            {currentGroup.name}
                        </Typography>
                    </Box>
                }
                {/* {
                    currentUser &&
                    <Button onClick={handleOpenMenu} aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} >
                        PROFILE
                    </Button>
                }
                <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} slotProps={{list: {'aria-labelledby': 'basic-button',sx: {padding: 0}}}}>
                    <MenuItem onClick={handleLogOut} sx={{'&:hover': { backgroundColor: '#0F5385',color:"white"}}}>Log Out</MenuItem>
                </Menu> */}
                {
                    currentUser &&
                    <Button onClick={handleLogOut}>
                        LOG OUT
                    </Button>
                }
                </Toolbar>
            </Container>
        </AppBar>
        <Outlet/>
    </>
    )
}

export default NavBar